import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/User/Home.vue';
import store from '@/store';
import { ElMessage } from 'element-plus';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/main',
    children: [
      {
        path: '/main',
        name: 'Main',
        component: () => import('../views/User/Main/Index.vue'),
      },
      {
        path: '/service',
        name: 'Service',
        redirect: '/service/legacy',
        component: () => import('../views/User/Service/Index.vue'),
        children: [
          {
            path: '/service/legacy',
            component: () => import('../views/User/Service/views/Legacy.vue'),
          },
          {
            path: '/service/claim',
            component: () => import('../views/User/Service/views/Claim.vue'),
          },
          {
            path: '/service/receipt',
            component: () => import('../views/User/Service/views/Receipt.vue'),
          },
          {
            path: '/service/special_case',
            component: () =>
              import('../views/User/Service/views/SpecialCase.vue'),
          },
          {
            path: '/service/seat',
            component: () =>
              import('../views/User/Service/views/SeatSelection.vue'),
          },
        ],
      },
      {
        path: '/guide',
        name: 'Guide',
        redirect: '/guide/illustrate',
        component: () => import('../views/User/Guide/Index.vue'),
        children: [
          {
            path: '/guide/illustrate',
            component: () => import('../views/User/Guide/views/Illustrate.vue'),
          },
          {
            path: '/guide/insurance_plane',
            component: () =>
              import('../views/User/Guide/views/InsurancePlane.vue'),
          },
          {
            path: '/guide/insurance_ticket',
            component: () =>
              import('../views/User/Guide/views/InsuranceTicket.vue'),
          },
          {
            path: '/guide/passenger',
            component: () =>
              import('../views/User/Guide/views/PassengerClause.vue'),
          },
        ],
      },
      {
        path: '/info',
        name: 'Info',
        redirect: '/info/person_info',
        component: () => import('../views/User/Info/Index.vue'),
        children: [
          {
            path: '/info/person_info',
            component: () => import('../views/User/Info/views/PersonInfo.vue'),
          },
          {
            path: '/info/all_order',
            component: () => import('../views/User/Info/views/Order.vue'),
          },
        ],
      },
      {
        path: '/booking',
        name: 'Book',
        component: () => import('../views/User/Book/Booking.vue'),
      },
      {
        path: '/buy_ticket',
        name: 'BuyTicket',
        component: () => import('../views/User/Book/BuyTicket.vue'),
      },
    ],
  },
  {
    path: '/entrance',
    name: 'Entrance',
    component: () => import('../views/Entrance/Index.vue'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Entrance/views/Login.vue'),
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('../views/Entrance/views/Register.vue'),
      },
      {
        path: '/findPassword',
        name: 'FindPassword',
        component: () => import('../views/Entrance/views/FindPassword.vue'),
      },
      {
        path: '/404',
        name: '404',
        component: () => import('../views/Entrance/views/404.vue'),
      },
    ],
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin/Index.vue'),
    redirect: '/admin/dashboard',
    children: [
      {
        path: '/admin/dashboard',
        name: 'DashBoard',
        component: () => import('../views/Admin/views/DashBoard.vue'),
      },
      {
        path: '/admin/user',
        name: 'User',
        component: () => import('../views/Admin/views/User.vue'),
      },
      {
        path: '/admin/order',
        name: 'Order',
        component: () => import('../views/Admin/views/Order.vue'),
      },
      {
        path: '/admin/flight',
        name: 'Flight',
        component: () => import('../views/Admin/views/Flight.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 访问控制
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    if (store.state.userInfo.isLogin) {
      next(false);
      ElMessage({
        showClose: true,
        message: '您已经登录，请注销后再登录！',
        type: 'error',
      });
    } else {
      next();
    }
  } else if (to.path === '/register') {
    if (store.state.userInfo.isLogin) {
      next(false);
      ElMessage({
        showClose: true,
        message: '您已经登录，请注销后再注册！',
        type: 'error',
      });
    } else {
      next();
    }
  } else if (to.path === '/findPassword') {
    if (store.state.userInfo.isLogin) {
      ElMessage({
        showClose: true,
        message: '您已经登录，请注销后再访问改页面！',
        type: 'error',
      });
      next(false);
    } else {
      next();
    }
  } else if (to.path === '/buy_ticket') {
    if (from.path === '/booking') {
      if (store.state.userInfo.isLogin) {
        next();
      } else {
        next('/login');
      }
    } else {
      // '/'代表通过直接打网址或者刷新进入
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next(false);
      }
    }
  } else if (to.path === '/info/person_info') {
    if (store.state.userInfo.isLogin === false) {
      ElMessage({
        showClose: true,
        message: '请先登录再进行访问',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    } else {
      next();
    }
  } else if (to.path === '/info/all_order') {
    if (store.state.userInfo.isLogin === false) {
      ElMessage({
        showClose: true,
        message: '请先登录再进行访问',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    } else {
      next();
    }
  } else if (to.path === '/service/seat') {
    if (store.state.userInfo.isLogin === false) {
      ElMessage({
        showClose: true,
        message: '请先登录再进行访问',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    } else {
      next();
    }
  } else if (to.path === '/service/receipt') {
    if (store.state.userInfo.isLogin === false) {
      ElMessage({
        showClose: true,
        message: '请先登录再进行访问',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    } else {
      next();
    }
  } else if (to.path === '/service/claim') {
    if (store.state.userInfo.isLogin === false) {
      ElMessage({
        showClose: true,
        message: '请先登录再进行访问',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    } else {
      next();
    }
  } else if (to.path === '/service/special_case') {
    if (store.state.userInfo.isLogin === false) {
      ElMessage({
        showClose: true,
        message: '请先登录再进行访问',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    } else {
      next();
    }
  } else if (to.path.indexOf('admin') >= 0) {
    if (store.state.userInfo.isLogin && store.state.userInfo.isAdministrator) {
      next();
    } else {
      ElMessage({
        showClose: true,
        message: '权限不足！',
        type: 'error',
      });
      if (from.path === '/') {
        router.push('main');
        next(false);
      } else {
        next('/login');
      }
    }
  } else if (to.matched.length !== 0) {
    next();
  } else {
    next({ path: '/404' });
  }
});

export default router;
